import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/core/assets/logo.png'


const _hoisted_1 = { class: "login-bg" }
const _hoisted_2 = { class: "row vh-100 justify-content-center align-items-center mx-0" }
const _hoisted_3 = { class: "col-sm-8 col-md-3 offset-md-9 px-0" }
const _hoisted_4 = { class: "card pb-1 border vh-100 bg-light position-relative" }
const _hoisted_5 = { class: "card-body px-4" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}
const _hoisted_7 = { class: "text-center mt-2 mb-4 h5" }
const _hoisted_8 = { class: "form-group ml-auto" }
const _hoisted_9 = { class: "row align-self-end h-100" }
const _hoisted_10 = { class: "col form-group mt-1 text-left cookie-opacity ml-1" }
const _hoisted_11 = {
  href: "https://www.coats.com/en/Privacy-and-Cookie-Policy",
  class: "btn-link"
}
const _hoisted_12 = { class: "card-footer bg-transparent border-0 text-center" }
const _hoisted_13 = { class: "mb-0 mt-3 text-center" }
const _hoisted_14 = { class: "row label-text d-none d-md-block" }
const _hoisted_15 = { href: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-header bg-transparent border-0" }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo-badge bg-white shadow p-4 p-md-4 text-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo",
              class: "img-fluid log-min-h"
            })
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "shadow-element" }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("landingPage.welcome")), 1)
            ]),
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.activeUser == null)
                  ? (_openBlock(), _createBlock(_component_BButton, {
                      key: 0,
                      variant: "primary",
                      class: "my-2 my-sm-0 btn-sm btn-block",
                      type: "button",
                      onClick: _ctx.login,
                      disabled: _ctx.busy,
                      style: {"background-color":"#0054a6","color":"white"}
                    }, {
                      default: _withCtx(() => [
                        (_ctx.busy)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              icon: "spinner",
                              spin: ""
                            }))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("landingPage.ssoLogin")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]))
                  : (_openBlock(), _createBlock(_component_BButton, {
                      key: 1,
                      variant: "primary",
                      class: "my-2 my-sm-0",
                      type: "button",
                      onClick: _ctx.login,
                      disabled: _ctx.busy,
                      style: {"background-color":"#0054a6","color":"white"}
                    }, {
                      default: _withCtx(() => [
                        (_ctx.busy)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              icon: "spinner",
                              spin: ""
                            }))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("landingPage.continue")) + " " + _toDisplayString(_ctx.activeUserName), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t("landingPage.privacyCookies")), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, "© Coats Digital " + _toDisplayString(_ctx.year), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t("landingPage.publishedOn")) + " " + _toDisplayString(_ctx.date), 1)
    ])
  ]))
}